module.exports = __webpack_public_path__ + "img/Trinidad-&-Tabago.b4d0aa11.png";